module.exports = __webpack_public_path__ + "img/xlm-icon.1db3eb21.svg";